/*---------------------------------------------------------*\
 * PageLayoutSecondaryController
\*---------------------------------------------------------*/
import keyboard from 'keycode-ui';

const deps = {};

class PageLayoutSecondaryController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($state, navigationService, adProps) {
    this.$state = $state;

    this.selectedIndex = 0;
    this.name = 'pageLayoutSecondary';
    this.adProps = adProps;
    deps.navigationService = navigationService;
  }

  //-----------------------------------
  // Methods
  //-----------------------------------

  onLeftNavKeyDown(e, index) {
    if (keyboard.isRight(e)) {
      e.preventDefault();
      deps.navigationService.focusElAsync(index === 0 ? 'navbar' : '.main-content');
    }
  }

  navSelect(item) {
    if (item && item.state) {
      this.$state.go(item.state, {}, { reload: true });
    }
  }
}

PageLayoutSecondaryController.$inject = [
  '$state',
  'navigationService',
  'adProps'
];

export default PageLayoutSecondaryController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/pageLayoutSecondary/pageLayoutSecondary.controller.js
 **/